import React from "react";

const SectionIntro = ({ backgroundColor, textClass, text, className }) => {
  return (
    <div className={`section-intro ${className} ${backgroundColor}`}>
      <h2 className={`whitespace-pre-wrap f1 text-center ${textClass}`}>
        {text}
      </h2>
    </div>
  );
};

export default SectionIntro;
